import Link from "astro-typesafe-routes/link/react";

import { useLocale } from "~/hooks/locale";
import type { Locale } from "~/i18n";

export const NavItems: React.FC<{ locale: Locale }> = ({ locale }) => {
  const { t } = useLocale(locale);
  return (
    <>
      <li>
        <Link to="/play">{t("play")}</Link>
      </li>
      <li>
        <Link to="/packs">{t("packs")}</Link>
      </li>
      <li>
        <Link to="/teachers">{t("teachers")}</Link>
      </li>
      <li>
        <Link to="/pricing">{t("pricing")}</Link>
      </li>
    </>
  );
};
